import styled from '@emotion/styled';

const S = { Icon: {} };

S.Icon.Circle = styled.div`
  label: Circle;

  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: var(--colors-honey-gold-base);
`;

export default S;
